module.exports = __webpack_public_path__ + "static/media/Lacapital-Studio-Option1-Cam-01.ea242b9a.webp";